import { render } from "./EmailRenderer.vue?vue&type=template&id=c44f5008&scoped=true"
import script from "./EmailRenderer.vue?vue&type=script&lang=js"
export * from "./EmailRenderer.vue?vue&type=script&lang=js"

import "./EmailRenderer.vue?vue&type=style&index=0&id=c44f5008&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c44f5008"]])

export default __exports__